'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validators = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _formValidator = require('./form-validator');

Object.defineProperty(exports, 'validators', {
    enumerable: true,
    get: function get() {
        return _formValidator.validators;
    }
});
exports.formNameToObject = formNameToObject;
exports.formBuilder = formBuilder;

var _isObject = require('./isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('./isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function formNameToObject(dotedString, value) {
    var props = dotedString.split('.').entries();
    return createObject(props, value);
}
function createObject(props, value) {
    var next = props.next();
    if (next.done) {
        return value;
    }

    var _next$value = _slicedToArray(next.value, 2),
        _idx = _next$value[0],
        propName = _next$value[1];

    return _defineProperty({}, propName, createObject(props, value));
}
function isFormBuilderInstance(obj) {
    return ['validate', 'merge', 'getState'].reduce(function checkIfBuilderInstance(result, fnName) {
        return result === true ? obj != null && (0, _isFunction2.default)(obj[fnName]) : result;
    }, true);
}
function formBuilder(config) {
    /* eslint-disable prefer-const */
    var _Object$entries$reduc = Object.entries(config)
    /* eslint-enable prefer-const */
    .reduce(function (newState, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            paramName = _ref3[0],
            fieldConfig = _ref3[1];

        if (isFormBuilderInstance(fieldConfig)) {
            return {
                state: Object.assign({}, newState.state, _defineProperty({}, paramName, fieldConfig)),
                validation: Object.assign({}, newState.validation, _defineProperty({}, paramName, fieldConfig))
            };
        } else {
            var _fieldConfig = _slicedToArray(fieldConfig, 2),
                initialValue = _fieldConfig[0],
                _fieldConfig$ = _fieldConfig[1],
                _validators = _fieldConfig$ === undefined ? [] : _fieldConfig$;

            return {
                state: Object.assign({}, newState.state, _defineProperty({}, paramName, initialValue)),
                validation: Object.assign({}, newState.validation, _defineProperty({}, paramName, (0, _formValidator.buildFormValidator)(_defineProperty({}, paramName, _validators))))
            };
        }
    }, {}),
        state = _Object$entries$reduc.state,
        validation = _Object$entries$reduc.validation;

    function validate() {
        var currentState = getState();
        return Object.entries(validation).reduce(function (errors, _ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                paramName = _ref5[0],
                validator = _ref5[1];

            if (isFormBuilderInstance(validator)) {
                return Object.assign({}, errors, _defineProperty({}, paramName, Object.assign({}, validator.validate())));
            } else {
                return Object.assign({}, errors, validator(currentState));
            }
        }, {});
    }
    function getState() {
        return Object.entries(state).reduce(function (returnedState, _ref6) {
            var _ref7 = _slicedToArray(_ref6, 2),
                paramName = _ref7[0],
                value = _ref7[1];

            if (isFormBuilderInstance(value)) {
                return Object.assign({}, returnedState, _defineProperty({}, paramName, value.getState()));
            } else {
                return Object.assign({}, returnedState, _defineProperty({}, paramName, value));
            }
        }, {});
    }
    function merge(params) {
        state = Object.entries(params).filter(function (_ref8) {
            var _ref9 = _slicedToArray(_ref8, 2),
                _a = _ref9[0],
                value = _ref9[1];

            return value != null;
        }).reduce(function (newState, _ref10) {
            var _ref11 = _slicedToArray(_ref10, 2),
                paramName = _ref11[0],
                value = _ref11[1];

            if ((0, _isObject2.default)(value) && isFormBuilderInstance(state[paramName])) {
                state[paramName].merge(value);
                return newState;
            } else {
                return Object.assign({}, newState, _defineProperty({}, paramName, value));
            }
        }, state);
        return getState();
    }
    return { validate: validate, merge: merge, getState: getState };
}
//# sourceMappingURL=form-builder.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/form-builder.js